<template>
  <DefaultLayout :pageClass="this.currentStep === 1 || this.currentStep === 3 ? 'defaultPageStart' :
    this.currentStep === 2 || this.currentStep === 4 || this.currentStep === 5 ? 'defaultPageCenter' : ''">
    <component :is="currentComponent" :user-info="userInfo" :percentage="percentage" :giftText="giftText || (route.path === '/en' ? giftsEn.noGift : giftsEl.noGift)"
      @update-user-info="updateUserInfo" @submit-user-info="submitUserInfo" @next-step="nextStep" 
      @quiz-finished="goToLastQuizStep" @return-home="returnHome" />
  </DefaultLayout>
</template>

<script>
import Step1 from './components/form-page.vue';
import Step2 from './components/start-quiz.vue';
import Step3 from './components/quiz-flow.vue';
import Step4 from './components/performance-page.vue';
import Step5 from './components/final-page.vue';
import { useRoute } from 'vue-router';

export default {
  components: {
    Step1,
    Step2,
    Step3,
    Step4,
    Step5
  },
  data() {
    return {
      currentStep: 1,
      percentage: 0,
      userInfo: {
        fname: '',
        lname: '',
        email: '',
        newsletter: false,
        acceptGdpr: false,
      },
      hashedEmail: '',
      giftText: null,
      route: useRoute(),
      giftsEl: {
        "ESPRESSO_MACHINE": {
          "topBold": "Συγχαρητήρια!",
          "bottomNormal": "Κερδίσατε μία μηχανή illy.",
        },
        "MOLESKINE_ZAGNOLI_ILLY": {
          "topBold": "Συγχαρητήρια!",
          "bottomNormal": "Κερδίσατε ένα MOLESKINE ZAGNOLI illy!",
        },
        "TRAVEL_MUG_ILLY": {
          "topBold": "Συγχαρητήρια!",
          "bottomNormal": "Κερδίσατε 6 TRAVEL MUG ILLY!",
        },
        "noGift": {
          "topBold": "Ευχαριστούμε που γίνατε μέρος της εμπειρίας",
          "topNormal": "\"Why We Make It\"!",
          "bottomNormal": "Stay tuned – και ανακαλύψτε τα “γιατί” που κρύβονται πίσω από τον καφέ illy.",
        }
      },
      giftsEn: {
        "ESPRESSO_MACHINE": {
          "topBold": "Congratulations!",
          "bottomNormal": "You have won an illy machine.",
        },
        "MOLESKINE_ZAGNOLI_ILLY": {
          "topBold": "Congratulations!",
          "bottomNormal": "You have won an illy MOLESKINE ZAGNOLI!",
        },
        "TRAVEL_MUG_ILLY": {
          "topBold": "Congratulations!",
          "bottomNormal": "You have won 6 ILLY TRAVEL MUGS!",
        },
        "noGift": {
          "topBold": "Thank you for being part of the",
          "topNormal": "\"Why We Make It\" experience!",
          "bottomNormal": "Stay tuned — and discover all the \"whys\" behind illy coffee.",
        }      }
    };
  },
  computed: {
    currentComponent() {
      return `Step${this.currentStep}`;
    },
  },
  methods: {
    updateUserInfo(newUserInfo) {
      this.userInfo = newUserInfo;
    },
    submitUserInfo(hashedEmail) {
      if (this.currentStep < 5) {
        this.currentStep++;
      }
      this.hashedEmail = hashedEmail;
      console.log("Form Data Submitted:", this.userInfo);
    },
    nextStep() {
      if (this.currentStep < 5) {
        this.currentStep++;
        window.scrollTo(0, 0);
      }
    },
    async goToLastQuizStep(payload) {
      this.percentage = payload.percentage;
      this.currentStep = 4;

      const quizAnswers = payload.results.map(item =>
          item.correct ? "correct" : "wrong"
      );


      const dataWithQuizResults = {
        questions: quizAnswers
      };

      let requestOptions = {
        method: 'PUT',
        body: JSON.stringify(dataWithQuizResults),
        headers: {'Content-Type': 'application/json'}
      };
      console.log('dataWithQuizResults', dataWithQuizResults);

      await fetch(`https://questions-with-rewards-api.ocm.workers.dev/api/${this.hashedEmail}`, requestOptions)
          .then(async (response) => {
            const data = await response.json();
            const gifts = this.route.path === '/en' ? this.giftsEn : this.giftsEl;
            const selectedGift = gifts[data?.gift] ?? gifts.noGift;

            if (data?.gift === 'ESPRESSO_MACHINE' && data?.giftPosition) {
              this.giftText = {
                ...selectedGift,
                bottomNormal: this.route.path === '/en'
                    ? `You are ${data.giftPosition} of the day's 2 big winners!`
                    : `Είστε ο ${data.giftPosition} από τους 2 μεγάλους τυχερούς της ημέρας!`,
                bottomNormalSecond: this.route.path === '/en'
                    ? 'You have won an illy Iperespresso machine!'
                    : 'Κερδίσατε μια μηχανή illy Iperespresso!',
              };
            } else {
              this.giftText = selectedGift;
            }
          })
          .catch(error => console.error('Error upload user:', error));
    
  },
    returnHome() {
      this.userInfo = {
        fname: '',
        lname: '',
        email: '',
        newsletter: false,
        acceptGdpr: false,
      };
      this.currentStep = 1;
      this.hashedEmail = '';
      this.percentage = 0;
      window.scrollTo(0, 0);
    }
  }
};
</script>
